import {config} from "../../config";

const ProcessRackModel = (data, itemId) => {
    return ({
        step: config.processingSteps.STEP_05,
        source: {
            chainCode: data.chainCodes[0],
        },
        destination: {
            itemId: itemId,
            loadAmount: data?.loadAmount || 0,
            waste: data?.waste || 0,
            weight: data?.weight || 0
        },
    })
}

export default ProcessRackModel
